var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _vm.index
      ? _c(
          "div",
          { class: { bold: _vm.isFolder }, on: { click: _vm.toggle } },
          [
            _vm.isFolder
              ? _c("span", [
                  _c("i", {
                    class: [_vm.open ? "fas fa-folder-open" : "fas fa-folder"]
                  }),
                  _vm._v(" " + _vm._s(_vm.index) + " 1")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isFolder && !_vm.deleted
              ? _c("span", [
                  _c("i", { staticClass: "fas fa-file" }),
                  _c("a", { attrs: { href: _vm.model["download"] } }, [
                    _vm._v(" " + _vm._s(_vm.index) + " ")
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-link btn-small text-danger",
                        attrs: { "aria-label": "Delete", type: "button" },
                        on: { click: _vm.deleteFile }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-fw",
                          class: _vm.loading
                            ? "fa-spinner fa-pulse"
                            : "fas fa-trash-alt"
                        })
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isFolder
      ? _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ]
          },
          _vm._l(_vm.model, function(model, index) {
            return _c("file", {
              key: index,
              staticClass: "file m-1",
              attrs: { model: model, index: index }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c75d7da", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c75d7da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/file.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-8c75d7da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/file.vue
// module chunks = 0